"use strict";

var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js");
var _asyncToGenerator = require("/opt/build/repo/node_modules/@babel/runtime/helpers/asyncToGenerator.js");
var _inherits = require("/opt/build/repo/node_modules/@babel/runtime/helpers/inherits.js");
var _possibleConstructorReturn = require("/opt/build/repo/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
var _getPrototypeOf = require("/opt/build/repo/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass.js");
var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck.js");
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UrlAccountCreator = exports.LocalAccountCreator = exports.AccountCreator = void 0;
var web_1 = require("./utils/web");
/**
 * Account creator provides an interface for implementations to actually create accounts
 */
var AccountCreator = /*#__PURE__*/_createClass(function AccountCreator() {
  _classCallCheck(this, AccountCreator);
});
exports.AccountCreator = AccountCreator;
var LocalAccountCreator = /*#__PURE__*/function (_AccountCreator) {
  _inherits(LocalAccountCreator, _AccountCreator);
  var _super = _createSuper(LocalAccountCreator);
  function LocalAccountCreator(masterAccount, initialBalance) {
    var _this;
    _classCallCheck(this, LocalAccountCreator);
    _this = _super.call(this);
    _this.masterAccount = masterAccount;
    _this.initialBalance = initialBalance;
    return _this;
  }
  /**
   * Creates an account using a masterAccount, meaning the new account is created from an existing account
   * @param newAccountId The name of the NEAR account to be created
   * @param publicKey The public key from the masterAccount used to create this account
   * @returns {Promise<void>}
   */
  _createClass(LocalAccountCreator, [{
    key: "createAccount",
    value: function () {
      var _createAccount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(newAccountId, publicKey) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.masterAccount.createAccount(newAccountId, publicKey, this.initialBalance);
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function createAccount(_x, _x2) {
        return _createAccount.apply(this, arguments);
      }
      return createAccount;
    }()
  }]);
  return LocalAccountCreator;
}(AccountCreator);
exports.LocalAccountCreator = LocalAccountCreator;
var UrlAccountCreator = /*#__PURE__*/function (_AccountCreator2) {
  _inherits(UrlAccountCreator, _AccountCreator2);
  var _super2 = _createSuper(UrlAccountCreator);
  function UrlAccountCreator(connection, helperUrl) {
    var _this2;
    _classCallCheck(this, UrlAccountCreator);
    _this2 = _super2.call(this);
    _this2.connection = connection;
    _this2.helperUrl = helperUrl;
    return _this2;
  }
  /**
   * Creates an account using a helperUrl
   * This is [hosted here](https://helper.nearprotocol.com) or set up locally with the [near-contract-helper](https://github.com/nearprotocol/near-contract-helper) repository
   * @param newAccountId The name of the NEAR account to be created
   * @param publicKey The public key from the masterAccount used to create this account
   * @returns {Promise<void>}
   */
  _createClass(UrlAccountCreator, [{
    key: "createAccount",
    value: function () {
      var _createAccount2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(newAccountId, publicKey) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return web_1.fetchJson("".concat(this.helperUrl, "/account"), JSON.stringify({
                newAccountId: newAccountId,
                newAccountPublicKey: publicKey.toString()
              }));
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function createAccount(_x3, _x4) {
        return _createAccount2.apply(this, arguments);
      }
      return createAccount;
    }()
  }]);
  return UrlAccountCreator;
}(AccountCreator);
exports.UrlAccountCreator = UrlAccountCreator;